import React from "react";
import SideBarNav from "./SideBarNav";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import NotificationAlert from "react-notification-alert";
import { connect } from "react-redux";
import { updatePassword } from "../../modules/actions/authActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import PropTypes from "prop-types";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.oldPassword)) {
    errors.oldPassword = "This field is required";
  }
  if (Validator.isEmpty(data.newPassword)) {
    errors.newPassword = "This field is required";
  }
  if (Validator.isEmpty(data.confirm_password)) {
    errors.confirm_password = "This field is required";
  }

  if (!Validator.equals(data.newPassword, data.confirm_password)) {
    errors.confirm_password = "Passwords must match";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class UpdatePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirm_password: "",
      errors: {},
      isLoading: false,
      invalid: false
    };
  }

  handleProfileUpdate = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { oldPassword, newPassword } = this.state;

      const payload = {
        oldPassword,
        newPassword
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
        .updatePassword(payload)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.setState({
              oldPassword : "",
              newPassword : "",
              confirm_password : ""
            });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "success",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          } else {
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
        });
    }
  };

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  render() {
    const { errors, oldPassword, newPassword, confirm_password } = this.state;
    return (
      <section className="BodyContainer">
        <div className="container">
          <div className="row">
            <SideBarNav />
            <div className="col-lg-8">
              <div className="mt-0">
                <NotificationAlert ref="notify" />

                <div style={{ clear: "both", height: "15px" }} />

                <h4 className="features_title">Update Password</h4>

                <div style={{ clear: "both", height: "15px" }} />

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <input
                        type="password"
                        name="oldPassword"
                        className="form-control"
                        value={oldPassword}
                        onChange={this._onChange}
                        placeholder="Current Password"
                      />
                      {errors.oldPassword && (
                        <span className="error-color-dash">
                          {errors.oldPassword}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <input
                        type="password"
                        className="form-control"
                        name="newPassword"
                        onChange={this._onChange}
                        value={newPassword}
                        placeholder="New Password"
                      />
                      {errors.newPassword && (
                        <span className="error-color-dash">
                          {errors.newPassword}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <input
                        type="password"
                        className="form-control"
                        name="confirm_password"
                        onChange={this._onChange}
                        value={confirm_password}
                        placeholder="Confirm New Password"
                      />
                      {errors.confirm_password && (
                        <span className="error-color-dash">
                          {errors.confirm_password}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group mt-3">
                      <a
                        href="javascript:void(0)"
                        onClick={this.handleProfileUpdate}
                        className="btn btn-custom w-100"
                      >
                        SAVE
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    profile: state.auth.profile
  };
}
export default connect(
  mapStateToProps,
  {
    updatePassword
  }
)(UpdatePassword);



// WEBPACK FOOTER //
// ./src/pages/dashboard/UpdatePassword.js